module.exports = __webpack_public_path__ + "img/donante-fundacion-codet.fd087aec.jpeg";